import { Link } from 'react-router-dom';
import { Home, Search, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

/**
 * NotFound Page (P20251023-UI-P5D)
 * 
 * Branded 404 page for unknown SPA routes with helpful CTAs
 */
export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full">
        <CardContent className="pt-12 pb-8 px-6 text-center">
          {/* 404 Visual */}
          <div className="mb-8">
            <div className="text-8xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              404
            </div>
            <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mt-4">
              Page Not Found
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-2 max-w-md mx-auto">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <Button asChild size="lg" className="w-full sm:w-auto">
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Go Home
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
              <Link to="/domains">
                <Search className="mr-2 h-4 w-4" />
                Browse Domains
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
              <Link to="/contact">
                <Mail className="mr-2 h-4 w-4" />
                Contact Support
              </Link>
            </Button>
          </div>

          {/* Footer hint */}
          <p className="text-sm text-gray-500 dark:text-gray-500 mt-8">
            Looking for something specific?{' '}
            <Link to="/contact" className="text-purple-600 hover:text-purple-700 dark:text-purple-400 underline">
              Let us know
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
